import { IChatMessage, IChatMessageFragment } from "../Interfaces";

export class ChatMessage implements IChatMessage {
    id: string;
    chatId: string;
    messageNo: number;
    time: number;
    messageType: string;
    props: any;
    fragments: IChatMessageFragment[];
    bot_conversation?: boolean;

    constructor(data: IChatMessage) {
        this.id = data.id;
        this.chatId = data.chatId;
        this.messageNo = data.messageNo;
        this.time = data.time;
        this.messageType = data.messageType;
        this.props = data.props;
        this.fragments = data.fragments || [];

    }

    public addFragment(fragment: IChatMessageFragment) {
        this.fragments.push(fragment);
    }

    public getLastFragment(): IChatMessageFragment | undefined {
        return this.fragments[this.fragments.length - 1];
    }
}
